// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__vTWS-","tab":"ProcedureTabs_tab__OY1pR"};